export default __webpack_public_path__ + "static/media/iusd3.de19fba1.png";